import { isAU } from './crux';

const COUNTRY = isAU ? 'au' : 'nz';
const urlToUse = `https://www.cotality.com/${COUNTRY}`;
const PDP = 'pdp';
const SIDE_MENU = 'side-menu';
const RP_DATA = 'rpdata';
const REFERRAL = 'referral';

const getCityscopeLink = (origin = '') => {
    const baseUrl = `${urlToUse}/products/cityscope`;

    const params = new URLSearchParams({
        utm_source: RP_DATA,
        utm_medium: REFERRAL,
        utm_campaign: '17809679-Cityscope RP Data cross promotion April 2025',
        utm_content: origin === PDP ? 'property-detail-page' : 'cityscope-side-menu',
        cid: '701Oa00000YfVCLIA3'
    });

    return encodeURI(`${baseUrl}?${params.toString()}`);
};

const getPlezzelLink = (origin = '') => {
    const baseUrl = `${urlToUse}/products/plezzel`;
    const params = new URLSearchParams({
        utm_source: RP_DATA,
        utm_medium: REFERRAL,
        utm_campaign: origin === PDP ? 'plezzel-pdp-btn' : 'plezzel-side-menu',
    })
    return `${baseUrl}?${params.toString()}`;
};

export const links = {
    privacyPolicy: `${urlToUse}/legal/privacy-policy`,
    termsOfUse: `${urlToUse}/legal/terms-conditions`,
    contactUs: `${urlToUse}/support`,
    disclaimers: `${urlToUse}/legal/disclaimers`,
    plezzelPdp: getPlezzelLink(PDP),
    plezzelSideMenu: getPlezzelLink(SIDE_MENU),
    cityscopePdp: getCityscopeLink(PDP),
    cityscopeSideMenu: getCityscopeLink(SIDE_MENU),
}